export default {
	props: {
		/**
		 * The size of the icon. Available valus: `xx-small(xxs), x-small(xs), small(sm), medium(md), large(lg)`.
		 */
		size: {
			type: String,
			default: 'medium',
		}
	},
	computed: {
		getSize() {
			switch (this.size) {
			case 'xxxs':
			case 'xxx-small':
				return { fontSize: '8px' };
			case 'xxs':
			case 'xx-small':
				return { fontSize: '10px' };
			case 'xs':
			case 'x-small':
				return { fontSize: '12px' };
			case 'sm':
			case 'small':
				return { fontSize: '16px' };
			case 'md':
			case 'medium':
				return { fontSize: '20px' };
			case 'lg':
			case 'large':
				return { fontSize: '32px' };
			case 'xl':
			case 'x-large':
				return { fontSize: '40px' };
			default:
				return { fontSize: this.size };
			}
		},
	}
};